module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"signIn":"Log in","registration":"Sign up","speed":"Network speed test","support":"Support"},"ru":{"signIn":"Войти","registration":"Зарегистрироваться","speed":"Скорость сети","support":"Поддержка"}}')
  delete Component.options._Ctor
}
